import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import {
  createSettlement,
  getRayonForModal,
  updateSettlement,
} from "../../../../../redux/directoryMaintenance/settlementsReducer/actionsSettlements";

import UniversalModal from "../../universalModal";

import {
  headerName,
  setDataSettlements,
  getSettlementsModal,
  getSettlementsEditModal,
} from "./constantsSettlementsModal";
import NotificationWindow from "../../../../../components/GeneralComponents/NotificationWindow/NotificationWindow";

import { CHANGE_SETTLEMENTS_IS_SAVE, GET_SETTLEMENTS_NO_ERROR } from "../../../../../redux/types";

import styles from "./settlementsModal.module.css";

const AdministrativeDistrictsModal = ({ setShow, show, type, setSave }) => {
  const dispatch = useDispatch();

  const [fields, setFields] = useState([]);
  const [initialFieldsData, setInitialFieldsData] = useState({});
  const [showNotificationWindow, setShowNotificationWindow] = useState(false);
  const [isError, setIsError] = useState(true);

  const allOblast = useSelector((state) => {
    const { dictionaryReducer } = state;
    return dictionaryReducer.allOblast;
  });

  const allLocalityCategory = useSelector((state) => {
    const { dictionaryReducer } = state;
    return dictionaryReducer.allLocalityCategory;
  });

  const settlementData = useSelector((state) => {
    const { settlementsReducer } = state;
    return settlementsReducer;
  });

  const settlement = useSelector((state) => {
    const { settlementsReducer } = state;
    return settlementsReducer.settlement;
  });

  const searchParams = useSelector((state) => {
    const { settlementsReducer } = state;
    return settlementsReducer.searchParams;
  });

  const rayonByOblast = useSelector((state) => {
    const { settlementsReducer } = state;
    return settlementsReducer.rayonModal;
  });

  async function setParamsForOptions() {
    await setDataSettlements(allOblast, "oblastId");
    await setDataSettlements(allLocalityCategory, "categoryId");

    if (type === "add") {
      setFields(Object.values(getSettlementsModal()));
    }
    if (type === "edit") {
      setFields(Object.values(getSettlementsEditModal()));
    }
  }

  const handleSaveClick = async (data) => {
    if (type === "add") {
      dispatch(
        createSettlement(
          {
            oblast: data.oblastId,
            rayon: data.rayonId,
            category: data.categoryId,
            nameRu: data.nameRu,
            nameBy: data.nameBy,
            datein: data.datein,
            dateout: data.dateout,
          },
          searchParams,
        ),
      );
    }

    if (type === "edit") {
      dispatch(
        updateSettlement(
          settlement.id,
          {
            dateout: data.dateout,
          },
          searchParams,
        ),
      );
    }
  };

  const handleOnChange = (data) => {
    if (data.oblastId) {
      dispatch(getRayonForModal(data.oblastId));
    }
  };

  const handleOnHide = () => {
    setShow(false);
    dispatch({
      type: GET_SETTLEMENTS_NO_ERROR,
      data: "",
    });
    dispatch({
      type: CHANGE_SETTLEMENTS_IS_SAVE,
    });
  };

  useEffect(() => {
    if (!settlementData.isSave && settlementData.error !== "") {
      setShowNotificationWindow(!showNotificationWindow);
      setIsError(true);
    }
    if (settlementData.isSave && settlementData.error === "") {
      dispatch({
        type: CHANGE_SETTLEMENTS_IS_SAVE,
      });
      setIsError(false);
      setSave();
      setShow(false);
    }
  }, [settlementData.isSave, settlementData.error, isError]);

  useEffect(() => {
    setParamsForOptions().then();
  }, []);

  useEffect(() => {
    if (settlement?.oblastId) {
      dispatch(getRayonForModal(settlement.oblastId));
    }
  }, [type]);

  useEffect(() => {
    if (type === "add") {
      setDataSettlements(rayonByOblast, "rayonId");
      setFields(Object.values(getSettlementsModal()));
    }
  }, [rayonByOblast, dispatch]);

  useEffect(() => {
    const initialData = {};
    fields.forEach((field) => {
      initialData[field.key] = field.type === "text" ? "" : null;
    });
    setInitialFieldsData(initialData);
  }, [fields]);

  return (
    <>
      <UniversalModal
        show={show}
        onHide={() => handleOnHide()}
        onSave={(data) => handleSaveClick(data)}
        onChange={(data) => handleOnChange(data)}
        fields={fields}
        initialFieldsData={initialFieldsData}
        initialData={settlement}
        headerName={headerName[type]}
        type={type}
        size="lg"
        stylesFromParent={styles}
        isError={isError}
      />
      <NotificationWindow
        isError={showNotificationWindow}
        show={showNotificationWindow}
        setShow={setShowNotificationWindow}
        headerText={"Уведомление"}
        messageText={settlementData.error}
      />
    </>
  );
};

export default AdministrativeDistrictsModal;
